<template>
  <div>
    <div
      v-for="category in ResponseCategories.filter(c => !c.Is_Archived)
        .slice()
        .sort($orderByCategory)"
      :key="category.Application_Template_Response_Category_Id"
      class="mt-2 card"
    >
      <div class="card-header">
        <div class="row">
          <div class="col-auto pr-1">
            <i
              class="material-icons float-left pointer"
              v-bind:id="
                category.Application_Template_Response_Category_Id +
                  'toggleIcon'
              "
              data-toggle="collapse"
              v-bind:href="
                '#responses' +
                  category.Application_Template_Response_Category_Id
              "
              role="button"
              aria-expanded="false"
              v-on:click="
                $updateToggleIcon(
                  '#' +
                    category.Application_Template_Response_Category_Id +
                    'toggleIcon'
                )
              "
              >add</i
            >
          </div>
          <div
            class="col-auto pointer pl-1"
            v-on:click="
              $updateToggleIcon(
                '#' +
                  category.Application_Template_Response_Category_Id +
                  'toggleIcon'
              )
            "
            data-toggle="collapse"
            v-bind:href="
              '#responses' + category.Application_Template_Response_Category_Id
            "
          >
            <h6 class="d-inline">{{ category.Category }}</h6>
          </div>
          <div class="col-auto pl-0">
            <button
              v-bind:id="
                'summary' + category.Application_Template_Response_Category_Id
              "
              class="btn text-left px-0 py-0 mb-1"
              style="height:26px;"
              data-toggle="popover"
              data-trigger="focus"
              v-on:click="
                $focusElement(
                  'summary' + category.Application_Template_Response_Category_Id
                )
              "
              data-placement="right"
              v-bind:data-content="category.Summary"
            >
              <i class="material-icons-outlined pointer">info</i>
            </button>
          </div>
          <div class="col" />
        </div>
      </div>
      <div
        class="card-body collapse"
        v-bind:id="
          'responses' + category.Application_Template_Response_Category_Id
        "
      >
        <div
          v-for="response in category.Application_Template_Responses"
          :key="response.Application_Template_Response_Id"
          class="row"
        >
          <div class="col-auto px-0">
            <button
              class="btn btn-sm btn-link"
              v-on:click="addGrantApplicationResponse(response)"
            >
              Use
            </button>
          </div>
          <div class="col">
            <p class="mb-1">
              <u>{{ response.Question }}</u>
            </p>
            <p
              style="white-space: pre-wrap;"
              v-html="$cleanResponse(response.Response)"
            ></p>
            <p />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResponseCategories",
  props: {
    ResponseCategories: Array
  },
  data() {
    return {};
  },
  methods: {
    addGrantApplicationResponse(response) {
      this.$emit("addGrantApplicationResponse", response);
    }
  }
};
</script>
